/* Vissla custom: BEGIN vissla-custom.js
   Newsletter popup behavior ported from Impulse 7.3.3 (Vissla edit in the old theme.js):
   - The popup must NEVER auto-open.
   - It opens only when #inline-popup (footer-new "Sign Up For Our Newsletter") is clicked,
     by dispatching 'reminder:openNewsletter', which theme.js's NewsletterPopup listens for.
   Auto-open suppression (stock 9.1.0 has no "disable auto-show" setting):
   1. sessionStorage 'newsletterAppeared' = 'true' diverts the delayed auto-open to the
      reminder path on this page load (the reminder block is disabled, so nothing shows).
   2. The section's own 'newsletter-<sectionId>' cookie suppresses auto-open on later loads.
   Also popup_seconds is set to 60 in sections/popup-group.json as defense in depth.
*/
(function () {
  try {
    sessionStorage.setItem('newsletterAppeared', 'true');
  } catch (e) {
    /* no-op: sessionStorage unavailable */
  }

  var popup = document.querySelector('[data-section-type="newsletter-popup"]');
  if (popup) {
    var sectionId = popup.getAttribute('data-section-id');
    if (sectionId && document.cookie.indexOf('newsletter-' + sectionId + '=') === -1) {
      document.cookie = 'newsletter-' + sectionId + '=opened; path=/; max-age=31536000';
    }
  }

  function bindTrigger() {
    var trigger = document.getElementById('inline-popup');
    if (!trigger || trigger.dataset.visslaPopupBound === 'true') {
      return;
    }
    trigger.dataset.visslaPopupBound = 'true';
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('reminder:openNewsletter', { bubbles: true }));
    });
  }

  if (document.readyState !== 'loading') {
    bindTrigger();
  } else {
    document.addEventListener('DOMContentLoaded', bindTrigger);
  }
})();
/* Vissla custom: END vissla-custom.js */

/* Vissla custom: BEGIN product features modal */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.features-box') || !window.theme || !theme.Modals) return;
  var featureModal = new theme.Modals('FeaturePopup', 'feature-popup-modal');
  document.querySelectorAll('.features-box a').forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.feature-content').forEach(function (el) { el.style.display = 'none'; });
      var t = document.querySelector('.feature-content[data-name="' + item.getAttribute('data-name') + '"]');
      if (t) t.style.display = 'block';
      featureModal.open();
    });
  });
});
/* Vissla custom: END product features modal */

/* Vissla custom: BEGIN help-accordion (vanilla replacement for old jQuery accordion; restores FAQ answers that were display:none with no opener) */
(function () {
  function initAccordion() {
    var headers = document.querySelectorAll('.accordion li > h3, .accordion li > h4');
    if (!headers.length) return;
    headers.forEach(function (h) {
      h.style.cursor = 'pointer';
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      function toggle() {
        var li = h.parentElement;
        var open = li.classList.toggle('open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }
  if (document.readyState !== 'loading') initAccordion();
  else document.addEventListener('DOMContentLoaded', initAccordion);
})();
/* Vissla custom: END help-accordion */

/* Vissla custom: BEGIN gallery-lightbox (vanilla replacement for Fancybox on creator galleries + lookbook carousels; intercepts existing a[rel="fancybox-gallery"] links, no markup change) */
(function () {
  var SEL = 'a[rel="fancybox-gallery"]';
  function imgUrl(a) { return a.getAttribute('href'); }
  function groupOf(a) {
    var c = a.closest('.gallery, .lookbooks-carousel');
    var scope = c || document;
    return Array.prototype.slice.call(scope.querySelectorAll(SEL));
  }
  var overlay, imgEl, counterEl, group, index;
  function build() {
    overlay = document.createElement('div');
    overlay.className = 'vissla-lb';
    overlay.innerHTML =
      '<button class="vissla-lb__close" aria-label="Close">&times;</button>' +
      '<button class="vissla-lb__prev" aria-label="Previous">&#8249;</button>' +
      '<figure class="vissla-lb__stage"><img class="vissla-lb__img" alt=""></figure>' +
      '<button class="vissla-lb__next" aria-label="Next">&#8250;</button>' +
      '<div class="vissla-lb__counter"></div>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.vissla-lb__img');
    counterEl = overlay.querySelector('.vissla-lb__counter');
    overlay.querySelector('.vissla-lb__close').addEventListener('click', close);
    overlay.querySelector('.vissla-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    overlay.querySelector('.vissla-lb__next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay || e.target.classList.contains('vissla-lb__stage')) close(); });
  }
  function show() {
    var a = group[index];
    imgEl.src = imgUrl(a);
    counterEl.textContent = (index + 1) + ' / ' + group.length;
    var multi = group.length > 1;
    overlay.querySelector('.vissla-lb__prev').style.display = multi ? '' : 'none';
    overlay.querySelector('.vissla-lb__next').style.display = multi ? '' : 'none';
  }
  function go(d) { index = (index + d + group.length) % group.length; show(); }
  function open(g, i) {
    if (!overlay) build();
    group = g; index = i;
    document.body.classList.add('vissla-lb-open');
    overlay.classList.add('is-open');
    show();
  }
  function close() {
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('vissla-lb-open');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest(SEL) : null;
    if (!a) return;
    e.preventDefault();
    var g = groupOf(a);
    open(g, g.indexOf(a));
  });
  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
  });
})();
/* Vissla custom: END gallery-lightbox */

/* Vissla custom: BEGIN hero-autoplay-defer starter (perf 2026-07). sections/slideshow.liquid now renders data-autoplay="false" server-side (with data-deferred-autoplay="true") so Flickity can never initialize auto-rotating; that fixed lab LCP misreading every slide swap as a new largest paint (16.9s on a page that paints in ~2s). This starter begins rotation on the first REAL user input. No 'scroll' (programmatic scrolls fire trusted scroll events) and no synthetic events (isTrusted must be true). Theme editor keeps normal autoplay via the liquid guard. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var hero = document.querySelector('[data-section-type="slideshow-section"] [id^="Slideshow-"][data-deferred-autoplay="true"]');
  if (!hero) return;
  var speed = parseInt(hero.dataset.speed, 10) || 7000;
  var events = ['touchstart', 'wheel', 'mousemove', 'keydown', 'click'];
  function start(e) {
    if (!e || e.isTrusted !== true) return;
    var f = window.Flickity && window.Flickity.data(hero);
    if (!f) return; /* slideshow not initialized yet; the next interaction retries */
    events.forEach(function (ev) { window.removeEventListener(ev, start); });
    f.options.autoPlay = speed;
    f.playPlayer();
  }
  events.forEach(function (ev) { window.addEventListener(ev, start, { passive: true }); });
})();
/* Vissla custom: END hero-autoplay-defer starter */
